<ng-template #requiredStar let-control="control">
  <span *ngIf="(control?.validator | asFunction)({})?.required">*</span>
</ng-template>

<ng-template #textInput let-fa="fa" let-formControl="formControl" let-key="key">
  <div class="col-12 col-lg-3 form-group">
    <label>
      <span>{{ extradata[key]?.display_field_name }}</span>
      <ng-container
        *ngTemplateOutlet="requiredStar; context:{control: formControl}"></ng-container>
      <fa-icon *ngIf="extradata[key]?.display_help" [icon]="infoIcon" [title]="extradata[key]?.display_help"
               class="info-icon ms-1"></fa-icon>
    </label>

    <div class="position-relative">
      <input [formControl]="formControl" class="form-control" type="text"/>
      <span [ngClass]="{visible:processingData[key]}" class="loading-icon">
                    <fa-icon [icon]="loadingIcon" animation="spin-pulse"></fa-icon>
                  </span>
    </div>
    <div *ngFor="let k of $any(validatorMessages[key]) | keyvalue">
      <san-form-input-error [message]="$any(k.value)"
                            [visible]="supressErrorMessage(fa, $any(k.key)) && formControl.hasError($any(k.key))"></san-form-input-error>
    </div>
  </div>
</ng-template>

<ng-template #gueltigAb let-fa="fa" let-formControl="formControl" let-key="key">
  <div class="col-10 col-lg-2 form-group">
    <label>
      <span>{{ extradata[key]?.display_field_name }}</span>
      <ng-container
        *ngTemplateOutlet="requiredStar; context:{control: formControl}"></ng-container>
      <fa-icon *ngIf="extradata[key]?.display_help" [icon]="infoIcon" [title]="extradata[key]?.display_help"
               class="info-icon ms-1"></fa-icon>
    </label>
    <div class="position-relative">
      <div class="input-group">
        <input (focusout)="setValueFromMaskedDate(formControl, true)"
               [(ngModel)]="maskDateValues[formControl.id]"
               (ngModelChange)="setValueFromMaskedDate(formControl)"
               [dropSpecialCharacters]="false"
               [ngModelOptions]="{standalone: true}"
               aria-label="Gültig ab"
               autocomplete="off"
               class="form-control"
               mask="d0.M0.0000"
               placeholder="TT.MM.JJJJ"
               type="text">
        <input #dp="ngbDatepicker"
               [formControl]="formControl"
               aria-label="Gültig ab"
               autocomplete="off"
               class="form-control fake-input"
               ngbDatepicker
               placeholder="TT.MM.JJJJ"
               tabindex="5">
        <span (click)="dp.toggle()" class="btn btn-outline-primary">
           <fa-icon [icon]="calendarIcon"></fa-icon>
        </span>
      </div>
      <span [ngClass]="{visible:processingData[key]}" class="loading-icon">
              <fa-icon [icon]="loadingIcon" animation="spin-pulse"></fa-icon>
            </span>
    </div>
    <div *ngFor="let k of $any(validatorMessages[key]) | keyvalue">
      <san-form-input-error [message]="$any(k.value)"
                            [visible]="supressErrorMessage(fa, $any(k.key)) && formControl.hasError($any(k.key))"></san-form-input-error>
    </div>
    <san-form-input-error [visible]="formControl.hasError('invalidDate')"
                          message="Das Datum ist nicht gültig."></san-form-input-error>
    <san-form-input-error [visible]="formControl.hasError('minDate')"
                          message="Das Datum darf nicht vor dem heutigen Datum liegen."></san-form-input-error>
  </div>
</ng-template>

<div>
  <div class="row">
    <div *ngIf="!($any(extradata)|keyvalue).length" [@vis] class="col-12"><p>wird geladen ...</p></div>
    <div *ngIf="($any(extradata)|keyvalue).length" [@vis] class="col-12">
      <div *ngFor="let vm of $any(formArray.controls); index as i; count as c"
           class="row remove-last-hr">
        <!-- FormControls: Gültig ab, Kontoinhaber, IBAN, BIC -->
        <ng-container
          *ngTemplateOutlet="textInput; context:{formControl: vm.controls[1], key: 'Sanakey/Bankverbindung/Kontoinhaber', fa: vm}"></ng-container>
        <ng-container
          *ngTemplateOutlet="textInput; context:{formControl: vm.controls[2], key: 'Sanakey/Bankverbindung/IBAN', fa: vm}"></ng-container>
        <ng-container
          *ngTemplateOutlet="textInput; context:{formControl: vm.controls[3], key: 'Sanakey/Bankverbindung/BIC', fa: vm}"></ng-container>
        <ng-container
          *ngTemplateOutlet="gueltigAb; context:{formControl: vm.controls[0], key: 'Sanakey/Bankdaten/Mit Gueltigkeit/Gueltig ab', fa: vm}"></ng-container>
        <div class="form-group col-2 col-lg-1 d-flex align-items-end justify-content-end">
          <div class="float-right">
            <a (click)="deleteRow($event, i)"
               [class.disabled]="c === 1"
               class="btn btn-outline-warning">
              <fa-icon [icon]="deleteIcon"></fa-icon>
            </a>
          </div>
        </div>
        <div class="col-12">
          <san-form-input-error
            [message]="'Bitte geben Sie Konto Inhaber, die IBAN und ein Gültigkeitsdatum an'"
            [visible]="vm.hasError('allOrNoneRequired')"></san-form-input-error>
        </div>
        <div class="form-group col-12">
          <hr>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <san-form-input-error [message]="'Bitte geben Sie mindestens eine Bankverbindung an'"
                                [visible]="formArray.hasError('minArrayLength')"></san-form-input-error>
        </div>
      </div>
      <div class="row">
        <div class="col-12 text-center">
          <button (click)="addEmptyRow()" class="btn btn-primary">weitere/neue Bankverbindung hinzufügen
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
